import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { selectHourlyRateEntryExists } from 'services/timesheetTimesheetEntriesForm/selectors';

interface Props {
    hourlyRateEntryExists?: ?boolean;
    children: React.Node;
}

export class HourlyRateEntryExistsGate extends React.PureComponent<Props> {
    render() {
        const { hourlyRateEntryExists, children } = this.props;
        if (!hourlyRateEntryExists) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector({
    hourlyRateEntryExists: selectHourlyRateEntryExists
});

export default connect(mapStateToProps)(HourlyRateEntryExistsGate);
